import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicBlock({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M12 6.75c.97 0 1.75.78 1.75 1.75v5c0 .97-.78 1.75-1.75 1.75H4c-.97 0-1.75-.78-1.75-1.75v-5c0-.97.78-1.75 1.75-1.75h8zm0 1.5H4a.25.25 0 00-.25.25v5c0 .14.11.25.25.25h8c.14 0 .25-.11.25-.25v-5a.25.25 0 00-.25-.25zm-3.5 1.5a1.25 1.25 0 01.25 2.47v.03a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5v-1.5h.02c.12-.57.63-1 1.23-1zm-.5-9c2.35 0 4.25 1.9 4.25 4.25v1a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5V5a2.75 2.75 0 00-5.5 0v1a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5V5C3.75 2.65 5.65.75 8 .75z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicBlock.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicBlock.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicBlock svgRef={ref} {...props} />);
export default ForwardRef;
